/**
 * Guarda a rota que o usuário tentou acessar antes de ser mandado para o /login
 * e a recupera após o login, para redirecioná-lo de volta (ex.: link de fatura no e-mail).
 *
 * Só aceita caminhos internos (relativos) para evitar open-redirect.
 */
const RETURN_URL_KEY = "barte-return-url";

const EXCLUDED_PREFIXES = ["/login", "/cadastro", "/redefinir-senha"];

export function isSafeInternalPath(path?: string | null): boolean {
  if (!path) return false;
  if (!path.startsWith("/")) return false; // precisa ser caminho interno absoluto
  if (path.startsWith("//")) return false; // protocol-relative -> externo
  if (path.includes("\\")) return false; // barra invertida (bypass)
  if (path.includes("://")) return false; // esquema embutido
  return true;
}

export function storeReturnUrl(path?: string | null): void {
  if (!isSafeInternalPath(path)) return;
  if (EXCLUDED_PREFIXES.some((prefix) => (path as string).startsWith(prefix))) return;
  localStorage.setItem(RETURN_URL_KEY, path as string);
}

export function clearReturnUrl(): void {
  localStorage.removeItem(RETURN_URL_KEY);
}

export function consumeReturnUrl(): string | null {
  const stored = localStorage.getItem(RETURN_URL_KEY);
  clearReturnUrl();
  return isSafeInternalPath(stored) ? stored : null;
}

/**
 * Retorna a rota de destino após o login: a rota guardada (se houver e for válida)
 * ou o `fallback` (destino padrão por role).
 */
export function resolvePostLoginRedirect(fallback: string): string {
  return consumeReturnUrl() ?? fallback;
}
